import { NumericFilter } from '@/api/generatedApi';

export const RANGE_OPERATORS = ['>', '>=', '<', '<='] as const;
export const NUMERIC_OPERATORS = [...RANGE_OPERATORS, '='] as const;
export const GRID_NUMERIC_OPERATORS = ['=', ...RANGE_OPERATORS] as const;

export type RangeOperatorSymbol = (typeof RANGE_OPERATORS)[number];
export type NumericOperatorSymbol = (typeof NUMERIC_OPERATORS)[number];

export const RANGE_SYMBOL_TO_API: Record<RangeOperatorSymbol, keyof NumericFilter> = {
  '>': 'gt',
  '>=': 'gte',
  '<': 'lt',
  '<=': 'lte',
};

export const RANGE_API_TO_SYMBOL = Object.fromEntries(
  Object.entries(RANGE_SYMBOL_TO_API).map(([symbol, api]) => [api, symbol])
) as Record<keyof NumericFilter, RangeOperatorSymbol>;

export const isNumericOperator = (operator: string): operator is NumericOperatorSymbol => {
  return NUMERIC_OPERATORS.includes(operator as NumericOperatorSymbol);
};

export const isRangeOperator = (operator: string): operator is RangeOperatorSymbol => {
  return RANGE_OPERATORS.includes(operator as RangeOperatorSymbol);
};
